import { redirectExternally } from "@/helpers/externalRedirect.js";

export const redirectToAuth = (authType, query = {}) => {
  const { VITE_API_URL: apiEndpoint } = import.meta.env;
  const redirectPath = authType === "login" ? "login" : "register";
  const queryString = new URLSearchParams(query).toString();
  const url = `${apiEndpoint}/auth/${redirectPath}${queryString ? "?" + queryString : ""}`;
  redirectExternally(url);
};
